module.exports = __webpack_public_path__ + "static/media/key.42e5458d.svg";